import React from 'react';
import './panier-step.css';
import withNavigation from '../../higher-order/navigation';
import PanierPage from '../../panier/panier-page';
import { useHasCampJourInCart } from './hooks/useHasCampJourInCart';
import { getStepNavigationLabels, StepNavigation } from './step-shared';

/**
 * Custom step component that embeds PanierPage in the formulaire flow.
 * Props:
 * - currentStep: index de l'étape actuelle
 * - totalSteps: nombre total d'étapes
 * - goToNextStep: fonction pour aller à l'étape suivante
 * - goToPreviousStep: fonction pour aller à l'étape précédente
 * - goToStep: fonction pour aller à une étape spécifique
 * - formData: objet de données du formulaire actuel
 * - language: langue actuelle
 */
const PanierStep = ({
  currentStep,
  totalSteps,
  goToNextStep,
  goToPreviousStep,
  goToStep,
  resetStepperAndGoToFirstStep,
  language,
}) => {
  const hasCampJourInCart = useHasCampJourInCart();

  const handleNext = () => {
    if (!hasCampJourInCart && resetStepperAndGoToFirstStep) {
      resetStepperAndGoToFirstStep();
    } else {
      goToNextStep();
    }
  };

  const t = {
    panierTitle: language === 'fr' ? 'Panier' : 'Cart',
    ...getStepNavigationLabels(language),
  };

  return (
    <div className="panier-step">
      <h2 className="panier-step-title">{t.panierTitle}</h2>

      <div className="panier-step-embedded">
        <PanierPage
          isBoutique={false}
          paiementRoute="AchatCampJour"
          reloadOnRemoveFromPanier={true}
        />
      </div>

      <StepNavigation
        currentStep={currentStep}
        totalSteps={totalSteps}
        onPrevious={goToPreviousStep}
        onNext={handleNext}
        labels={t}
        showNext={false}
        actionsClassName="panier-step-actions"
        previousClassName="panier-step-previous-button"
        nextClassName="panier-step-next-button"
      />
    </div>
  );
};

PanierStep.validate = (formData, language = 'fr') => {
  return {
    isValid: true,
    errors: {}
  };
};

export default withNavigation(PanierStep);